<script lang="ts" setup>
    import { computed } from "vue";

    const EXTERNAL_URL_REGEX = /^([a-z]+:)\/\//i;

    const props = defineProps({
        is: {
            default: "",
            type: String
        },
        href: {
            default: "",
            type: String
        },
        target: {
            default: "",
            type: String
        },
        rel: {
            default: "",
            type: String
        },
        theme: {
            default: "primary",
            type: String
        },
        outline: {
            default: false,
            type: Boolean
        },
        rounded: {
            default: false,
            type: Boolean
        },
        large: {
            default: false,
            type: Boolean
        },
        small: {
            default: false,
            type: Boolean
        }
    });

    const tag = computed((): string =>
    {
        if (props.is) { return props.is; }

        return props.href ? "a" : "button";
    });
    const classes = computed((): string[] =>
    {
        const _result: string[] = ["btn-"];

        if (props.outline) { _result[0] += "outline-"; }
        _result[0] += props.theme;

        if (props.large) { _result.push("btn-lg"); }
        else if (props.small) { _result.push("btn-sm"); }

        if (props.rounded) { _result.push("btn-rounded"); }

        return _result;
    });
    const properties = computed((): Record<string, string> =>
    {
        const _result: Record<string, string> = { };

        if (props.href)
        {
            _result["href"] = props.href;

            if (EXTERNAL_URL_REGEX.test(props.href))
            {
                _result["target"] = "_blank";
                _result["rel"] = "nofollow noopener noreferrer";
            }
        }

        if (props.target) { _result["target"] = props.target; }
        if (props.rel) { _result["rel"] = props.rel; }

        return _result;
    });
</script>

<template>
    <Component :is="tag"
               class="app-button btn"
               :class="classes"
               v-bind="properties">
        <slot></slot>
    </Component>
</template>

<style lang="scss" scoped>
    .app-button
    {
        border-radius: 0.5em;
        padding: 0.5em 1em;

        &.btn-light
        {
            border: 1px solid #E9D9FF;
            box-shadow: 0px 1px 2px #E9D9FF, inset 0px 0px 0px transparent;

            &:hover,
            &:focus
            {
                background-color: #F9FAFB;
            }
            &:active
            {
                background-color: #F9FAFB;
                border-color: #E9D9FF;
                box-shadow: 0px 0px 0px transparent, inset 0px 3px 5px #E9D9FF;
            }
        }
        &.btn-rounded
        {
            border-radius: 2em;
        }

        :deep(.feather-icon)
        {
            vertical-align: -2px;
        }
    }
</style>
